"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});
function getErrorMessage(operation) {
	var message = null;

	if (operation && operation.status === false) {
		if (operation.errors && operation.errors.length > 0) {
			message = operation.errors[0].value;
		}
	}

	return message;
}

exports.default = getErrorMessage;